import React from 'react';

const BdsTheme = {
  headerLogo: {
    src: '/themes/theme/bds/logo.png',
    alt: 'Brandfluencer',
    size: 40,
  },
  darkLogo: {
    src: '/themes/theme/bds/logo.png',
    alt: 'Brandfluencer Logo',
    size: 70,
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #A0CC3A',
    height: 80,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Brandfluencers',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <br /><br />
      <img height="80" src="/themes/theme/bds/logo.png" alt="Brandfluencers" />
      <h3>Brandfluencers</h3>
    </div>
  ),
  platformName: 'Brandfluencers',
  shareSite: 'https://brandfluencersanalytics.bdsmktg.com',
};

export default BdsTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/bds.js
 **/